const Komentar = function(DS) {
    return DS.defineResource({
        name: 'Komentar',
        endpoint: '/komentar'
    });
};

const NeprocitanKomentar = function(DS) {
    return DS.defineResource({
        name: 'NeprocitanKomentar',
        endpoint: '/komentar/neprocitani'
    });
};

Komentar.$inject = ['DS'];
NeprocitanKomentar.$inject = ['DS'];

const NOVI = 'Novi';
const PROCITAN = 'Procitan';

export { NOVI, PROCITAN, Komentar, NeprocitanKomentar };



// WEBPACK FOOTER //
// ./app/models/komentar.js